// extracted by mini-css-extract-plugin
export default {"snippets":"Paneli_snippets__gGMnz","snippet":"Paneli_snippet__EO7wf","snippetItem":"Paneli_snippetItem__wSreI"};